import { useState, useEffect } from 'react';
import { sessionService } from '../../../services/sessionService';
import { appointmentService } from '../../../services/appointmentService';

export const useSessionInitialization = (location) => {
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [appointmentData, setAppointmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    initializeSession();
  }, []);

  const initializeSession = async () => {
    setLoading(true);
    setError('');
    
    try {
      const appointmentId = location?.state?.appointmentId;
      
      if (!appointmentId) {
        setError('No appointment ID provided');
        setLoading(false);
        return;
      }

      const { data: appointment, error: appointmentError } = await appointmentService?.getAppointmentById(appointmentId);
      
      if (appointmentError || !appointment) {
        setError('Failed to load appointment details');
        setLoading(false);
        return;
      }

      setAppointmentData(appointment);

      const sessionId = `SES-2025-${Date.now()}`;
      const { data, error: sessionError } = await sessionService?.createSession({
        sessionId,
        appointmentId,
        helperId: appointment?.helperId,
        sessionType: 'video'
      });
      
      if (sessionError) {
        setError(sessionError?.message || 'Failed to initialize session');
        return;
      }
      
      setCurrentSessionId(data?.id);
    } catch (err) {
      setError(err?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return { currentSessionId, appointmentData, loading, error };
};